/** Specific vocabulary to be used to give repeatable content a distinct brand voice
 * @example
 * import { SainsburysVocab } from '@sainsburys-tech/vocab'
 *
 * return (
 *   <Button>{ SainsburysVocab.ADD_TO_TROLLEY }</Button>
 * )
 * @example
 * const Button = () => {
 * const { ADD_TO_TROLLEY } = useVocab()
 * return (
 *   <Button>{ ADD_TO_TROLLEY }</Button>
 * )
 */
const SainsburysVocab = {
  BRAND_NAME: "Sainsbury's",
  ADD_TO_TROLLEY: 'Add to trolley',
  ITEM_CONTAINER: 'trolley',
  ADD_TO_FAVOURITES: 'Add to favourites',
  ADDED_FAVOURITE: 'Added to favourites',
  FAILED_ADD_TO_FAVOURITES: 'Failed to add your favourite, try again soon',
  REMOVE_FROM_FAVOURITES: 'Remove from favourites',
  REMOVED_FAVOURITE: 'Removed from favourites',
  FAILED_REMOVE_FROM_FAVOURITES:
    'Failed to remove your favourite, try again soon'
}

export default SainsburysVocab
